<template>
    <v-container fill-height fluid grid-list-xl>
        <v-flex xs12>
            <v-layout row wrap>
                <v-flex xs12 md4>
                    <v-card class="pa-2 pb-4">
                        <v-layout column>
                            <v-layout justify-center class="pt-3 mb-2">
                                <v-card-title
                                    class="font-weight-regular text-xs-center display-1"
                                    >Tracking</v-card-title
                                >
                            </v-layout>

                            <div
                                class="text-xs-center font-weight-regular"
                                v-for="(track, index) in getTracks()"
                            >
                                <div>
                                    {{ track.description }}
                                </div>
                                <div
                                    v-if="track.amount"
                                    class="font-weight-light body-2"
                                >
                                    Amount: {{ track.amount | currency }}
                                </div>

                                <v-divider
                                    class="mt-2 mb-2 pb-1"
                                    v-if="index + 1 < getTracks().length"
                                    :key="index"
                                ></v-divider>
                            </div>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex xs12 md4>
                    <v-card
                        class="pa-2 pb-4"
                        @click="editGift()"
                        style="cursor: pointer "
                    >
                        <v-layout column>
                            <v-layout justify-center class="pt-3 mb-2">
                                <v-card-title
                                    class="font-weight-regular text-xs-center display-1"
                                    >Gifts</v-card-title
                                >
                            </v-layout>
                            <div
                                class="text-xs-center font-weight-regular"
                                v-for="(gift, index) in getGifts()"
                            >
                                <div>
                                    {{ gift.description }}
                                </div>
                                <div
                                    v-if="gift.value"
                                    class="font-weight-light body-2"
                                >
                                    Value: {{ gift.value | currency }}
                                </div>

                                <v-divider
                                    class="mt-2 mb-2 pb-1"
                                    v-if="index + 1 < getGifts().length"
                                    :key="index"
                                ></v-divider>
                            </div>
                        </v-layout>
                    </v-card>
                </v-flex>

                <v-flex xs12 md4>
                    <v-card
                        class="pa-2 pb-4"
                        @click="editGroup"
                        style="cursor: pointer "
                    >
                        <v-layout column>
                            <v-layout justify-center class="pt-3 mb-2">
                                <v-card-title
                                    class="font-weight-regular text-xs-center display-1"
                                    >Group</v-card-title
                                ></v-layout
                            >

                            <div class="" v-for="(group, index) in getGroups()">
                                <div
                                    class="text-xs-center font-weight-regular title"
                                >
                                    {{ group.groupName }}
                                </div>
                                <v-layout
                                    class="font-weight-light body-2 mb-2 mx-3"
                                >
                                    <div class="font-weight-regular mr-2">
                                        Branch:
                                    </div>
                                    {{ group.branch }}</v-layout
                                >
                                <v-layout
                                    class="font-weight-light body-2 mb-2 mx-3"
                                >
                                    <div class="font-weight-regular mr-2">
                                        Gabba:
                                    </div>
                                    {{ group.groupGabba }}</v-layout
                                >
                                <v-layout
                                    class="font-weight-light body-2 mb-2 mx-3"
                                >
                                    <div class="font-weight-regular mr-2">
                                        Note:
                                    </div>
                                    {{ group.note }}</v-layout
                                >
                                <v-layout
                                    row
                                    class="mx-3 font-weight-light body-2 mb-2"
                                    ><div class="font-weight-regular mr-2">
                                        Total Colleted:
                                    </div>
                                    {{
                                        group.totalColleted | currency
                                    }}</v-layout
                                >

                                <v-divider
                                    class="mt-2 mb-2 pb-1"
                                    v-if="index + 1 < getGroups().length"
                                    :key="index"
                                ></v-divider>
                            </div>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-dialog v-model="editGroupDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0">Group</v-card-title>
                <v-layout row v-for="(group, index) in groupsCopy">
                    <v-text-field
                        label="Year"
                        class="mx-2"
                        v-model="group.year"
                        ref="groupYear"
                        :rules="required"
                    />
                    <v-text-field
                        class="mx-2"
                        label="Name"
                        v-model="group.groupName"
                        ref="groupName"
                        :rules="required"
                    />
                    <v-text-field
                        label="Branch"
                        class="mx-2"
                        v-model="group.branch"
                    />
                    <v-text-field
                        class="mx-2"
                        label="Gabba"
                        v-model="group.groupGabba"
                    />
                    <v-text-field
                        class="mx-2"
                        label="Note"
                        v-model="group.note"
                    />
                    <v-text-field
                        class="mx-2"
                        type="number"
                        label="Total Colleted"
                        ref="totalColleted"
                        prefix="$"
                        v-model="group.totalColleted"
                    />
                    <v-btn
                        @click="deleteGroup(group)"
                        v-if="group.groupID"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        @click="addGroup"
                        flat
                        icon
                        color="success"
                        v-if="!group.groupID"
                    >
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn
                        @click="removeGroup(index)"
                        v-if="!group.groupID"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                </v-layout>
                <v-btn
                    block
                    color="#fff"
                    flat
                    @click="addGroup"
                    style="color: #aeb8bf; border: 1px dashed #aeb8bf; font-weight: 600"
                    >Add A Group</v-btn
                >
                <v-card-actions class="mx-0 mt-2 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeEditGroupDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="saveGroups"
                        :loading="processing"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editGiftDialog" max-width="600">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0">Gift</v-card-title>
                <v-layout row v-for="(gift, index) in giftsCopy">
                    <v-text-field
                        label="Year"
                        class="mx-2"
                        v-model="gift.year"
                        ref="giftYear"
                        :rules="required"
                    />
                    <v-text-field
                        class="mx-2"
                        label="Name"
                        v-model="gift.description"
                        ref="giftDescription"
                        :rules="required"
                    />
                    <v-text-field
                        class="mx-2"
                        label="value"
                        type="number"
                        v-model="gift.value"
                    />
                    <v-btn
                        @click="deleteGift(gift)"
                        v-if="gift.giftID"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        @click="addGift"
                        flat
                        icon
                        color="success"
                        v-if="!gift.giftID"
                    >
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn
                        @click="removeGift(index)"
                        v-if="!gift.giftID"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                </v-layout>
                <v-btn
                    block
                    color="#fff"
                    flat
                    @click="addGift"
                    style="color: #aeb8bf; border: 1px dashed #aeb8bf; font-weight: 600"
                    >Add A Gift</v-btn
                >
                <v-card-actions class="mx-0 mt-2 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeEditGiftDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="saveGifts"
                        :loading="processing"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editTrackingDialog" max-width="600">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0">Tracking</v-card-title>
                <v-layout row v-for="(track, index) in tracksCopy">
                    <v-text-field
                        class="mx-2"
                        label="Name"
                        v-model="track.description"
                        ref="trackDescription"
                        :rules="required"
                    />
                    <v-text-field
                        class="mx-2"
                        label="Name"
                        v-model="track.columnName"
                        ref="columnName"
                        :rules="required"
                    />
                    <v-text-field
                        class="mx-2"
                        label="Amount"
                        type="number"
                        v-model="track.amount"
                    />
                    <v-btn
                        @click="deleteTrack(track)"
                        v-if="track.code"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        @click="addTrack"
                        flat
                        icon
                        color="success"
                        v-if="!track.code"
                    >
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn
                        @click="removeTrack(index)"
                        v-if="!track.code"
                        flat
                        icon
                        color="#f55a4e"
                    >
                        <v-icon>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                </v-layout>
                <v-btn
                    block
                    color="#fff"
                    flat
                    @click="addTrack"
                    style="color: #aeb8bf; border: 1px dashed #aeb8bf; font-weight: 600"
                    >Add A Track</v-btn
                >
                <v-card-actions class="mx-0 mt-2 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeEditTrackDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="saveTracks"
                        :loading="processing"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteSettingDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 text-warning"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="pl-0 pt-0">
                    <v-layout row>
                        This will delete
                        <div class="font-weight-medium mx-1">
                            {{ settingToDelete.name }}
                        </div>
                        from the settings</v-layout
                    >
                </v-card-text>
                <v-card-actions class="mx-0 mt-2 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteSettingDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="deleteSetting"
                        :loading="deleting"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        settings: "",

        processing: false,
        deleting: false,

        editGroupDialog: false,
        editGiftDialog: false,
        editTrackingDialog: false,
        deleteSettingDialog: false,
        settingToDelete: {},

        setup: {},

        groupsCopy: "",
        giftsCopy: "",
        tracksCopy: "",

        required: [(value) => !!value || "Required."],
    }),
    watch: {},
    async created() {
        await this.loadSetup();

        this.loadSettings();
    },
    methods: {
        async loadSetup() {
            const setup = await this.$http.get(
                this.getDomain() + "/api/setup/getSetup"
            );

            this.setup = setup;
        },
        async loadSettings() {
            const settings = await this.$http.get(
                this.getDomain() + "/api/setup/getSettings"
            );

            this.settings = settings;
        },
        getTracks() {
            return this.settings.track;
        },
        getGroups() {
            return this.settings.group;
        },
        getGifts() {
            return this.settings.gift;
        },
        addGroup() {
            this.groupsCopy.push({
                groupID: null,
                year: this.setup.currentYear,
                groupName: "",
                branch: "",
                note: null,
                totalColleted: null,
                enteredOn: null,
                entreredBY: null,
                updatedOn: null,
                updatedBY: null,
                groupGabba: null,
            });
        },
        addGift() {
            this.giftsCopy.push({
                giftID: null,
                year: this.setup.currentYear,
                description: "",
                value: null,
                enteredBy: null,
                dateEntered: null,
                lastUpdatedBy: null,
                dateLastUpdated: null,
            });
        },
        addTrack() {
            this.tracksCopy.push({
                code: 0,
                description: "",
                type: "",
                columnName: "",
                amount: null,
            });
        },
        removeGroup(index) {
            this.groupsCopy.splice(index, 1);
        },
        removeGift(index) {
            this.giftsCopy.splice(index, 1);
        },
        removeTrack(index) {
            this.tracksCopy.splice(index, 1);
        },
        deleteGroup(group) {
            this.settingToDelete.data = group;
            this.settingToDelete.name = "Group: " + group.groupName;
            this.settingToDelete.action = "deleteGroup";
            this.settingToDelete.type = "group";

            this.deleteSettingDialog = true;
        },
        deleteGift(gift) {
            this.settingToDelete.data = gift;
            this.settingToDelete.name = "Gift: " + gift.description;
            this.settingToDelete.action = "deleteGift";
            this.settingToDelete.type = "gift";

            this.deleteSettingDialog = true;
        },
        deleteTrack(track) {
            this.settingToDelete.data = track;
            this.settingToDelete.name = "Gift: " + track.description;
            this.settingToDelete.action = "deleteTrack";
            this.settingToDelete.type = "track";

            this.deleteSettingDialog = true;
        },
        allowRemovingGroup(index) {
            const savedGroupsCount = this.settings.group.filter(
                (g) => g.groupID
            ).length;
            return index == savedGroupsCount;
        },
        validateGroups() {
            return this.groupsCopy
                .map((group, index) => {
                    return [
                        this.$refs.groupYear[index].validate(true),
                        this.$refs.groupName[index].validate(true),
                    ].every(Boolean);
                })
                .every(Boolean);
        },
        validateGifts() {
            return this.giftsCopy
                .map((gift, index) => {
                    return [
                        this.$refs.giftYear[index].validate(true),
                        this.$refs.giftDescription[index].validate(true),
                    ].every(Boolean);
                })
                .every(Boolean);
        },
        validateTracks() {
            return this.tracksCopy
                .map((gift, index) => {
                    return [
                        this.$refs.trackDescription[index].validate(true),
                        this.$refs.columnName[index].validate(true),
                    ].every(Boolean);
                })
                .every(Boolean);
        },
        async saveGroups() {
            if (!this.validateGroups()) return;

            this.processing = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/setup/saveGroupSetups",
                    this.groupsCopy.map((group) => {
                        if (group.groupID) {
                            group.updatedBY = this.$store.state.authentication.user;

                            return group;
                        }

                        group.groupID = 0;
                        group.entreredBY = this.$store.state.authentication.user;

                        return group;
                    })
                );

                this.processing = false;

                this.loadSettings();

                this.editGroupDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async saveGifts() {
            if (!this.validateGifts()) return;

            this.processing = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/setup/saveGiftSetups",
                    this.giftsCopy.map((gift) => {
                        if (gift.giftID) {
                            gift.value = gift.value ? gift.value : 0;
                            gift.lastUpdatedBy = this.$store.state.authentication.user;

                            return gift;
                        }

                        gift.giftID = 0;
                        gift.value = gift.value ? gift.value : 0;
                        gift.enteredBy = this.$store.state.authentication.user;

                        return gift;
                    })
                );

                this.processing = false;

                this.loadSettings();

                this.editGiftDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async saveTracks() {
            if (!this.validateTracks()) return;

            this.processing = true;

            try {
                await this.$http.post(
                    this.getDomain() + "/api/setup/saveTrackSetups",
                    this.tracksCopy.map((track) => {
                        if (track.code) {
                            return track;
                        }

                        track.code = 0;

                        return track;
                    })
                );

                this.processing = false;

                this.loadSettings();

                this.editTrackingDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteSetting() {
            this.deleting = true;

            try {
                await this.$http.post(
                    this.getDomain() +
                        "/api/setup/" +
                        this.settingToDelete.action,
                    this.settingToDelete.data
                );

                this.deleting = false;

                this.deleteSettingDialog = false;

                if (this.settingToDelete.type == "group") {
                    const index = this.groupsCopy.indexOf(
                        this.settingToDelete.data
                    );

                    this.removeGroup(index);
                }

                if (this.settingToDelete.type == "gift") {
                    const index = this.giftsCopy.indexOf(
                        this.settingToDelete.data
                    );

                    this.removeGift(index);
                }
            } catch (e) {
                this.deleting = false;
            }
        },
        closeEditGroupDialog() {
            this.editGroupDialog = false;

            this.loadSettings();
        },
        closeEditGiftDialog() {
            this.editGiftDialog = false;

            this.loadSettings();
        },
        closeEditTrackDialog() {
            this.editTrackingDialog = false;

            this.loadSettings();
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:44338"
                : "https://purim-admin-portal.azurewebsites.net";
        },
        editGroup() {
            this.groupsCopy = JSON.parse(JSON.stringify(this.settings.group));

            this.editGroupDialog = true;
        },
        editGift() {
            this.giftsCopy = JSON.parse(JSON.stringify(this.settings.gift));

            this.editGiftDialog = true;
        },
        editTrack() {
            this.tracksCopy = JSON.parse(JSON.stringify(this.settings.track));

            this.editTrackingDialog = true;
        },
        edit() {},
    },
};
</script>
<style>
.v-btn__content {
    color: unset;
}
</style>
